<template>
  <div style="background: #fff; position: relative;" @click="clickAll">
    <div class="mask" v-if="maskShow" @touchmove.prevent></div>
    <div class="search-tag" v-if="screenShow" id="myScreen">
      <div class="tag-con4">
        <div class="float-left tag-left2">类&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型</div>
        <div class='float-left tag-right'>
          <el-radio-group v-model='theme' size="small" border=false>
            <el-radio-button label="">不限</el-radio-button>
            <el-radio-button label="1">院线电影</el-radio-button>
            <el-radio-button label="2">网络电影</el-radio-button>
            <el-radio-button label="3">数字电影</el-radio-button>
            <el-radio-button label="4">电视剧</el-radio-button>
            <el-radio-button label="5">网络剧</el-radio-button>
            <el-radio-button label="6">广告拍摄</el-radio-button>
            <el-radio-button label="7">MV拍摄</el-radio-button>
            <el-radio-button label="8">综艺节目</el-radio-button>
            <el-radio-button label="9">演出活动</el-radio-button>
            <el-radio-button label="10">其他</el-radio-button>
          </el-radio-group>

        </div>
        <div class="clearfix"></div>
      </div>
      <div class="tag-con4">
        <div class="float-left tag-left2">招募演员</div>
        <div class='float-left tag-right'>
          <el-radio-group v-model='recruit' size="small" border=false>
            <el-radio-button label="">不限</el-radio-button>
            <el-radio-button label="1">男演员</el-radio-button>
            <el-radio-button label="2">女演员</el-radio-button>
            <el-radio-button label="3">老人演员</el-radio-button>
            <el-radio-button label="4">儿童演员</el-radio-button>
            <el-radio-button label="5">跟组演员</el-radio-button>
            <el-radio-button label="6">群众演员</el-radio-button>
            <el-radio-button label="7">特约演员</el-radio-button>
            <el-radio-button label="8">特技演员</el-radio-button>
            <el-radio-button label="9">特型演员</el-radio-button>
          </el-radio-group>

        </div>
        <div class="clearfix"></div>
      </div>
      <div class="tag-con4">
        <div class="float-left tag-left2">筹备地点</div>
        <div class='float-left tag-right'>
          <el-radio-group v-model='prepare' size="small" border=false>
            <el-radio-button label="">不限</el-radio-button>
            <el-radio-button label="1">北京</el-radio-button>
            <el-radio-button label="2">上海</el-radio-button>
            <el-radio-button label="3">浙江横店</el-radio-button>
          </el-radio-group>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="tag-con4">
        <div class="float-left tag-left2">拍摄地点</div>
        <div class='float-left tag-right'>
          <el-radio-group v-model='take_place' size="small" border=false>
            <el-radio-button label="">不限</el-radio-button>
            <el-radio-button label="1">北京</el-radio-button>
            <el-radio-button label="2">上海</el-radio-button>
            <el-radio-button label="3">浙江横店</el-radio-button>
            <el-radio-button label="4">其他</el-radio-button>

          </el-radio-group>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="tag-con4">
        <div class="float-left tag-left2">开机时间</div>
        <div class='float-left tag-right'>
          <el-radio-group v-model='date' size="small" border=false>
            <el-radio-button label="3">不限</el-radio-button>
            <el-radio-button label="1">半年以内开机</el-radio-button>
            <el-radio-button label="2">半年以上开机</el-radio-button>
          </el-radio-group>
        </div>
        <div class="clearfix"></div>
      </div>
      <div style="margin: 0 auto;display: flex;justify-content: space-around;">
        <input type="button" class="bk-search-btn" value="筛选" @click="getsearch"/>
        <input type="button" class="bk-search-btn" value="取消" @click="cancel"/>
      </div>

    </div>

    <!--轮播图-->
    <div>
      <swiper :options="swiperOption">
        <swiper-slide v-for="item in groupListSlide" :key="item.id">
          <img :src="item.images.image_url" style="width: 100%;height: auto" alt="banner">
        </swiper-slide>
      </swiper>
    </div>

    <div class="crew-details">
      <div style="background: #fff; height: 100%;">
        <div class="searchActorBtn" @click="Screening">
          <p>点击输入筛选条件</p>
        </div>
      </div>
      <ul class="crewDetailsContent">
        <li v-for="item in crewList" :key="item.id" class="crewDetails-info">
          <router-link style="display: flex;width: 100%" :to="{
              name:'Group',
              params:{
                id:item.id
              }
            }">
            <div class="crewDetailscrew-img-wrapper">
              <img :src="item.picture" class="crewDetails-img" :alt="item.movie_name">
            </div>
            <div class="crewDetails-introduction">
              <p class="crew-text" style="width: 4.2rem">影片名称：{{item.movie_name}}</p>
              <p class="crew-text">影片类型：{{item.theme}}</p>
              <p class="crew-text" style="width: 4.2rem">出品方：{{item.make}}</p>
              <p class="crew-text" style="width: 4.2rem">筹备地点：{{item.prepare}}</p>
              <p class="crew-text">开机时间：{{item.start_time}}</p>
              <p class="crew-text" style="width: 4.2rem">暂定拍摄地点：{{item.take_place}}</p>
              <p class="crew-text" style="width: 4.2rem">作品简介：{{item.synopsis}}</p>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <v-page :total-row="totalRow" align="center" :page-size-menu="false" :info="false"
            @page-change="pageChange" v-if="this.err !== 20001"></v-page>
    <div v-show="this.err === 20001"
         style="font-size: .4rem;width: 100%;display: flex;justify-content: center;color: red;"><p>没有相关数据</p></div>

  </div>
</template>

<script>
  import {swiper, swiperSlide} from 'vue-awesome-swiper'

  export default {
    name: "GroupList",
    data() {
      return {
        err: 0,
        maskShow: false,
        screenShow: false,
        infoP: {},
        theme: '',
        date: '3',
        recruit: '',
        prepare: '',
        take_place: '',
        totalRow: 0,
        crewList: [],
        pageArr: [],
        pageNum: 1,
        seoList: [],
        groupListSlide: [],
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 30,
          // loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
          effect: 'fade'
        }
      }
    },
    components: {
      swiper,
      swiperSlide
    },

    metaInfo() {
      return {
        title: this.seoList.column_title?`${this.seoList.column_title}-打造影视行业优秀的资源聚合服务平台`:'',
        meta: [{
          name: 'keywords',
          content: this.seoList.column_keywords
        },
          {
            name: 'description',
            content: this.seoList.column_description
          }]
      }
    },

    methods: {
      getSeo() {
        let seoApi = 'https://api.yopoo.cn/api/v1/crewsearch'
        this.$http.get(seoApi)
          .then((res) => {
            this.seoList = res.data.metas
          }, err => {
            console.log(err)
          })
      },
      Screening() {
        window.scrollTo(0, 0);
        this.screenShow = !this.screenShow
        this.maskShow = !this.maskShow
      },
      cancel() {
        this.screenShow = false
        this.maskShow = false
      },
      getsearch() {
        this.screenShow = false
        this.maskShow = false
        var api = 'https://api.yopoo.cn/api/v1/crewsearch?date=' + this.date + '&theme=' + this.theme + '&recruit=' + this.recruit +
          '&prepare=' + this.prepare + '&take_place=' + this.take_place + '&page=' + this.pageNum + '&count=' + this.infoP.pageSize + '&sort=esc' +
          '&order=id'
        this.$http.get(api).then((res) => {
          this.err = res.data.error_code
          this.crewList = res.data.data
          this.totalRow = res.data.pagination.total
        }, err => {
          console.log(err)
        })
      },
      getGroupSlide() {
        let aSwiperApi = 'https://api.yopoo.cn/api/v1/homeshow'
        this.$http.get(aSwiperApi, {
          params: {
            property: 2,
            count: 3
          }
        }).then(res => {
          this.groupListSlide = res.data
        }, err => {
          console.log(err)
        })
      },
      getCrewData() {
        this.$http.get('https://api.yopoo.cn/api/v1/crewsearch', {
          params: {
            page: this.pageNum,
            count: 5,
            column: 1
          }
        }).then((res) => {
          this.crewList = res.data.data
        }, (err) => {
          console.log(err)
        })
      },
      pageChange(pInfo) {
        pInfo.pageSize = 10
        this.pageNum = pInfo.pageNumber
        //for example, do some http request, get new data and update totalRow property
        var api = 'https://api.yopoo.cn/api/v1/crewsearch?date=' + this.date + '&theme=' + this.theme + '&recruit=' + this.recruit +
          '&prepare=' + this.prepare + '&take_place=' + this.take_place + '&page=' + this.pageNum + '&count=' + this.infoP.pageSize + '&sort=esc' +
          '&order=id'
        this.$http.get(api, {
          params: {
            page: this.pageNum,
            count: pInfo.pageSize,
          }
        }).then((res) => {
          this.crewList = res.data.data
          this.pageArr = res.data.pagination
          this.totalRow = res.data.pagination.total

        }, (err) => {
          console.log(err)
        })
        this.infoP = pInfo


      },
      clickAll(event) {
        let sp = document.getElementById("myScreen");
        if (sp) {
          if (!sp.contains(event.target)) { //如果是sp以外的地方
            this.screenShow = false
            this.maskShow = false
          }

        }

      }
    },
    beforeMount() {
      this.getGroupSlide()
      this.getSeo()
    }
  }
</script>

<style scoped>
  .search-tag {
    font-size: .3rem;
    position: absolute;
    z-index: 100051;
    height: 100vh;

  }

  .crew-details {
    background: #fff;
  }

  .crewDetails-info {
    display: flex;
    margin: .20rem;
    margin-top: 0;
    padding-top: .20rem;

  }

  .crewDetailscrew-img-wrapper {

  }

  .crewDetails-img {
    width: 2.2rem;
    height: 3.40rem;
  }

  .crewDetails-introduction {
    flex: 1;
    align-self: center;
    text-align: left;
    font-size: .25rem; /*rem*/
    font-weight: bold;
    font-family: MicrosoftYaHei;
    margin: 0 0.4rem;
    height: 3.40rem;
  }

  .crew-text {
    width: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .crew-text:nth-child(7) {
    width: 4.2rem;
  }

  .bk-search-btn {
    background: #191919;
    margin-top: 1rem;
    width: 1.8rem;
    height: .8rem;
    color: white;
    font-size: .3rem;
  }

  .search-tag {
    background: rgba(252, 252, 252, 1);
  }

  .searchActorBtn {
    font-size: .3rem;
    background: #191919;
    margin: .20rem .12rem;
    height: .60rem;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, .5);
  }
</style>



// WEBPACK FOOTER //
// src/components/GroupList.vue